import React from 'react';

import { useConfig } from '../../../../defaultConfig';
import useTranslation from '../../../../hooks/useTranslation';
import ToggleItemSkeleton from '../ToggleItem/ToggleItemSkeleton';
import AccountTransactionNotificationSettingsSkeleton from './AccountTransactionNotificationSettingsSkeleton';
import NotificationSettingsCategorySkeleton from './NotificationSettingsCategorySkeleton';
import SalaryNotificationSettingsSkeleton from './SalaryNotificationSettingsSkeleton';

const NotificationSwitchesSkeleton: React.FC = () => {
    const { pushNotifications: pushNotificationTexts } = useTranslation();
    const { featureToggles } = useConfig();
    return (
        <section className="notifications-settings__switches">
            <ToggleItemSkeleton className="notifications-settings__main-switch" heightOverride={84} withSubLabel />
            <h2 className="notifications-settings__rule-heading">{pushNotificationTexts.chooseNotificationsToGet}</h2>
            {featureToggles.rules.salary && <SalaryNotificationSettingsSkeleton />}
            <NotificationSettingsCategorySkeleton header={pushNotificationTexts.category.efaktura} count={4} />
            <NotificationSettingsCategorySkeleton header={pushNotificationTexts.category.account} count={1}>
                {featureToggles.rules.account && <AccountTransactionNotificationSettingsSkeleton />}
            </NotificationSettingsCategorySkeleton>
            <NotificationSettingsCategorySkeleton header={pushNotificationTexts.category.loan} count={1} />
            <ToggleItemSkeleton withSubLabel />
            <ToggleItemSkeleton withSubLabel />
        </section>
    );
};

export default NotificationSwitchesSkeleton;
